import React, { useState, useEffect } from 'react';
import NewsCard from './NewsCard';
import { getNews } from '../api';

const NewsGrid = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getNews(6, 0)
      .then(data => {
        // Убеждаемся, что data – массив (API возвращает сразу данные)
        setNews(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  if (loading) return <div>Загрузка новостей...</div>;

  return (
    <div className="news-grid">
      {news.map(item => (
        <NewsCard
          key={item.id}
          news={item}
          image={item.mainImage || (item.images && item.images[0])}
        />
      ))}
    </div>
  );
  
};

export default NewsGrid;